module.exports = __webpack_public_path__ + "img/wangweiqi.a6d67775.jpg";